import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


const ProceduresReportForm = () => {
  const [formData, setFormData] = useState({
    includeInactive: false,
    procedures: [],
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, multiple } = e.target;
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (multiple) {
      const options = Array.from(e.target.selectedOptions, option => option.value);
      setFormData(prevState => ({
        ...prevState,
        [name]: options
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px' ,marginLeft:"0px"}}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Inactive Selectable Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="includeInactive"
                checked={formData.includeInactive}
                onChange={handleChange}
                label="Inactive Selectable?"
                style={{ marginLeft: 0 }}
              />
            </Col>
          </Form.Group>

          {/* Procedures Multi-Select */}
          <Form.Group as={Row} controlId="procedures" className="mb-3">
            <Form.Label column sm="4" title="Please choose procedures to filter the report by">
              Procedures
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="procedures"
                value={formData.procedures}
                onChange={handleChange}
                multiple
                size="10"
                className="form-select"
                title="Please choose procedures to filter the report by"
              >
                <option value="">All</option>
                <option value="316">1-7 ALIGNERS (DUAL ARCH)</option>
                <option value="404">3D PRINTED MODELS</option>
                <option value="425">3D PRINTED MODEL (FULL PALATE)</option>
                <option value="426">3D PRINTED MODEL (HORSE SHOE SHAPE)</option>
                <option value="312">60% PRECIOUS GOLD CROWN</option>
                <option value="318">8-14 ALIGNERS (DUAL ARCH)</option>
                <option value="317">8-14 ALIGNERS (SINGLE ARCH)</option>
                <option value="351">ACRYLIC DENTURE WITH IMPLANT ATTACHMENT (4)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group as={Row} controlId="format" className="mb-3">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="form-select"
                title="Please choose a display format"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row} className="mb-0">
            <Col sm={{ span: 8, offset: 4 }}>
             <Link to="/Addproceduretaxes">
              <Button
                type="submit"
                variant="primary"
                className="w-100"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                <span className="ico-search"></span> Run
              </Button>
              </Link>
            </Col>
          </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default ProceduresReportForm;
